declare namespace $ {

	export class $shm_check_all extends $mol_check_box {
		checks( ): readonly($mol_check)[]
		Icon( ): $mol_icon_check_all
	}
	
}

//# sourceMappingURL=all.view.tree.d.ts.map